export const translateBackEndMessages = {
    back_end_validation: {
        custom: {

            'successMessage': "عملیات با موفقیت انجام شد",
            'errorMessage': 'عملیات انجام نشد.',
            'removeMessage': 'عملیات حذف با موفقیت انجام شد',
            'resourceNotFound': 'منبع درخواستی یافت نشد',
            'invalidCredential': 'نام کاربری یا رمز عبور اشتباه است.',
            'wrongPassword': 'رمز عبور اشتباه است.',

            'course': {
                'accessDenied': 'دسترسی به دوره مربوطه را ندارید.',
                'lessonNotFound': 'درس مربوط به دوره انتخاب شده یافت نشد.',
            },

            'email': {
                'verifiedBefore': 'ایمیل قبلاً تأیید شده است',
                'verified': 'ایمیل باموفقیت تأیید شده است',
                'sentCode': 'کد تایید ایمیل برای شما ارسال شد',
                'NotVerified': 'ایمیل تایید نشده است.',
                'passwordReset': 'ایمیل بازیابی رمز عبور با موفقیت برای شما ارسال شد',
                'emailNotfound': 'ایمیلی برای شما ثبت نشده است.',
            },

            'cellPhone': {
                'verifiedBefore': 'شماره قبلاً تأیید شده است',
                'verified': 'شماره تلفن وارد شده قبلا تایید شده است.',
                'verifiedSuccessfully': 'شماره تلفن با موفقیت تایید شد',
                'sentBefore': 'کد تایید قبلا برای شما ارسال شده است، لطفا 2 دقیقه دیگر امتحان کنید.',
                'sentCode': 'کد تایید برای شما ارسال شد',
                'codeInvalid': 'کد وارد شده اشتباه است',
                'yourPhoneNotVerified': 'شماره تلفن همراه شما تایید نشده است، لطفا در بخش داشبورد آن را تایید بفرمایید.',
                'resetPasswordSuccessfully': 'رمز عبور با موفقیت به روز رسانی شد',
                'yourLimitIsOver': "تعداد دفعات مجاز برای ارسال پیامک شما در امروز به پایان رسیده است"
            },

            'order': {
                'quantityLimitItOver': 'تعداد انتخاب شده در انبار موجود نمیباشد',
                'noItemToPay': 'هیچ موردی برای پرداخت وجود ندارد',
                'payed': 'این سفارش پرداخت شده است',
                'notFoundItemInOrder': 'محصول در سبد شما یافت نشد',
                'denyUpdateOrderItem': "امکان به روز رسانی سبد پرداخت شده وجود ندارد",
                "purchasedBefore": 'محصول انتخاب شده قبلا خریداری شده است',
            },

            'comments': {'modelNotFound': 'نوع کامنت درخواستی یافت نشد.'},

            'meta': {
                'MetaValuesCheckerError': 'مقادیر انتخابی قبلا ثبت شده است',
                'MetanotExist': 'meta درخواستی وجود ندارد'
            },

            'wallet': {
                'userCharge': "کیف پول شما :value تومان شارژ شد",
                'bonus': "سفارش شما :value تومان کیف پول شما را شارژ کرد",
                'payOrder': ":value تومان از کیف پول شما پرید.",
            }

        }
    }
}